import { EnvironmentProviders, inject, Injector, provideAppInitializer } from "@angular/core";
import { AppConfigService } from "../services/app-config.service";
import { switchMap } from "rxjs";
import { LanguageService } from "../services/language.service";

// https://github.com/angular/angular/pull/58518
export const AppInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  const initializerFn = ((appConfigService: AppConfigService, injector: Injector) => {
    return () => appConfigService.init()
    .pipe(switchMap(() => injector.get(LanguageService).init()));
  })(inject(AppConfigService), inject(Injector));
  return initializerFn();
});